import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { createPost } from "../redux/slices/postSlice";
import { toast } from "react-toastify";

const Createpost: React.FC = () => {
    const dispatch = useDispatch<any>();

    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [image, setImage] = useState<File | null>(null);
    const [video, setVideo] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    const toggleOpen = () => setIsOpen((prev) => !prev);
    const menuClass = isOpen ? 'show' : '';

    const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(e.target.value);
    };

    const handlePhotoVideoClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*,video/*';

        input.onchange = (e: Event) => {
            const target = e.target as HTMLInputElement;
            const file = target.files?.[0];

            if (file) {
                if (file.type.startsWith('image/')) {
                    setImage(file);
                    setVideo(null);
                } else if (file.type.startsWith('video/')) {
                    setVideo(file);
                    setImage(null);
                }
            }
        };

        input.click();
    };

    const handleSubmit = async () => {
        if (!message && !image && !video) {
            toast.warning("Please add some content");
            return;
        }

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("client_id", "43");
            formData.append("client_user_id", "36");
            formData.append("post_content", message);

            if (image) formData.append("post_image", image);
            if (video) formData.append("post_video", video);

            const res = await dispatch(createPost(formData)).unwrap();

            if (res?.status === true) {
                toast.success(res?.message || "Post created successfully");

                setMessage('');
                setImage(null);
                setVideo(null);
            } else {
                toast.error(res?.message || "Failed to create post");
            }

        } catch (err) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card w-100 shadow-xss rounded-xxl border-0 ps-4 pt-4 pe-4 pb-3 mb-3">
            <div className="card-body p-0">
                <div className="font-xssss fw-600 text-grey-500 d-flex align-items-center">
                    <i className="btn-round-sm font-xs text-primary feather-edit-3 me-2 bg-greylight"></i>
                    Create Post
                </div>
            </div>

            <div className="card-body p-0 mt-3 position-relative">
                <figure className="avatar position-absolute ms-2 mt-1 top-5">
                    <img
                        src="assets/images/user.png"
                        alt="icon"
                        className="shadow-sm rounded-circle w30"
                    />
                </figure>

                <textarea
                    name="message"
                    className="h100 bor-0 w-100 rounded-xxl p-2 ps-5 font-xssss text-grey-500 fw-500 border-light-md theme-dark-bg"
                    cols={30}
                    rows={5}
                    placeholder="What's on your mind?"
                    value={message}
                    onChange={handleTextChange}
                    disabled={loading}
                />
            </div>

            {(image || video) && (
                <div className="mt-2 mb-2 ps-5 font-xssss text-grey-500">
                    {image && <span>📷 {image.name}</span>}
                    {video && <span>🎥 {video.name}</span>}

                    <button
                        onClick={() => {
                            setImage(null);
                            setVideo(null);
                        }}
                        className="ms-2 text-danger"
                        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                    >
                        Remove
                    </button>
                </div>
            )}

            <div className="card-body d-flex p-0 mt-2">
                <a
                    href="#video"
                    onClick={(e) => e.preventDefault()}
                    className="d-flex align-items-center font-xssss fw-600 ls-1 text-grey-700 text-dark pe-4"
                >
                    <i className="font-md text-danger feather-video me-2"></i>
                    <span className="d-none-xs">Live Video</span>
                </a>

                <a
                    href="#photo"
                    onClick={handlePhotoVideoClick}
                    className="d-flex align-items-center font-xssss fw-600 ls-1 text-grey-700 text-dark pe-4"
                >
                    <i className="font-md text-success feather-image me-2"></i>
                    <span className="d-none-xs">Photo/Video</span>
                </a>

                <a
                    href="#activity"
                    onClick={(e) => e.preventDefault()}
                    className="d-flex align-items-center font-xssss fw-600 ls-1 text-grey-700 text-dark pe-4"
                >
                    <i className="font-md text-warning feather-camera me-2"></i>
                    <span className="d-none-xs">Feeling/Activity</span>
                </a>

                <button
                    onClick={handleSubmit}
                    disabled={loading || (!message && !image && !video)}
                    className="ms-auto btn btn-primary rounded-pill px-4 py-1 font-xssss fw-600"
                    style={{
                        background: loading ? '#ccc' : '#0d6efd',
                        border: 'none',
                        opacity: (!message && !image && !video) ? 0.5 : 1,
                        cursor: (!message && !image && !video) ? 'not-allowed' : 'pointer'
                    }}
                >
                    {loading ? 'Posting...' : 'Post'}
                </button>

                <div
                    className={`ms-2 pointer ${menuClass}`}
                    id="dropdownMenu4"
                    data-bs-toggle="dropdown"
                    aria-expanded={isOpen}
                    onClick={toggleOpen}
                >
                    <i className="ti-more-alt text-grey-900 btn-round-md bg-greylight font-xss"></i>
                </div>

                <div
                    className={`dropdown-menu p-4 right-0 rounded-xxl border-0 shadow-lg ${menuClass}`}
                    aria-labelledby="dropdownMenu4"
                >
                    <DropdownItem icon="feather-bookmark" title="Save Link" desc="Add this to your saved items" />
                    <DropdownItem icon="feather-alert-circle" title="Hide Post" desc="Save to your saved items" />
                    <DropdownItem icon="feather-alert-octagon" title="Hide all from Group" desc="Save to your saved items" />
                    <DropdownItem icon="feather-lock" title="Unfollow Group" desc="Save to your saved items" />
                </div>
            </div>
        </div>
    );
};

interface DropdownItemProps {
    icon: string;
    title: string;
    desc: string;
}

const DropdownItem: React.FC<DropdownItemProps> = ({ icon, title, desc }) => (
    <div className="card-body p-0 d-flex mt-2" style={{ cursor: 'pointer' }}>
        <i className={`${icon} text-grey-500 me-3 font-lg`}></i>
        <h4 className="fw-600 text-grey-900 font-xssss mt-0 me-4 pointer">
            {title}
            <span className="d-block font-xsssss fw-500 mt-1 lh-3 text-grey-500">
                {desc}
            </span>
        </h4>
    </div>
);

export default Createpost;